import React from "react";
import styled from "styled-components";
import { Scrollbars } from "react-custom-scrollbars";
import TabBody from "./TabBody";
import TabHeader from "./TabHeader";

const Body = styled(Scrollbars)`
  height: 100%;
  display: ${(props) => (props.show ? "block" : "none")};
`;

function DefaultTab({ show, setShow, ...props }) {
  const [isPause, setIsPause] = React.useState(false);
  const handleClick = () => {
    setIsPause(!isPause);
  };

  return (
    <Body
      renderView={(props) => <div {...props} />}
      autoHide
      autoHideTimeout={500}
      autoHideDuration={200}
      show={show === 0}
    >
      <TabHeader onClickPause={handleClick} />
      <TabBody setShow={setShow} isPause={isPause} />
    </Body>
  );
}

export default DefaultTab;
